import type {
  morphemeDetailsTileSliceQueryFn as morphemeDetailsTileSliceQueryFnFromMorphemeRead,
  useGetMorphemeDetailsTileSliceQueryKey,
} from "@-/dev.improve.haniverse.lib.morpheme.read";
import type { QueryClient } from "@-/com.npmjs.tanstack__react-query";
import { queryOptions } from "@-/com.npmjs.tanstack__react-query";
import { isCardCompleted } from "#morpheme-authoring-state";

export function filterCardsHidingAuthoringCompleted<
  Card extends { completed?: boolean | null; version?: number | null },
>(cards: readonly Card[], hideCompleted: boolean): Card[] {
  if (!hideCompleted) {
    return [...cards];
  }
  return cards.filter((card) => !isCardCompleted(card));
}

export async function filterCharactersHidingAuthoringCompleted(
  queryClient: QueryClient,
  morphemeDetailsTileSliceQueryFn: typeof morphemeDetailsTileSliceQueryFnFromMorphemeRead,
  getMorphemeDetailsTileSliceQueryKey: ReturnType<
    typeof useGetMorphemeDetailsTileSliceQueryKey
  >,
  characters: readonly string[],
  hideCompleted: boolean,
): Promise<string[]> {
  if (!hideCompleted) {
    return [...characters];
  }
  const cardsByCharacter = await Promise.all(
    characters.map(async (character) => {
      const card = await queryClient.fetchQuery(
        queryOptions({
          queryFn: morphemeDetailsTileSliceQueryFn,
          queryKey: getMorphemeDetailsTileSliceQueryKey({ morpheme: character }),
        }),
      );
      return { card, character };
    }),
  );
  return cardsByCharacter.flatMap(({ card, character }) => {
    return card === null || !isCardCompleted(card) ? [character] : [];
  });
}
